"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var HttpError = function HttpError(status, data) {
  this.isFoundHttpError = true;
  this.status = status;
  this.data = data;
};

exports["default"] = HttpError;
module.exports = exports.default;